import React from 'react';
import { Check, X } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Comparison = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const defaultFeatures = [
    {
      feature: 'Gestión profesional',
      jgm: '100% profesionales capacitados',
      others: '99% dirigidas por hombres sin experiencia'
    },
    {
      feature: 'Soporte',
      jgm: 'Soporte 24/7 personalizado',
      others: 'Soporte genérico o inexistente'
    },
    {
      feature: 'Costos iniciales',
      jgm: 'Sin costos de configuración',
      others: 'Hasta USD 20.000 de tarifa inicial'
    },
    {
      feature: 'Calendario de contenido',
      jgm: 'Nuestros directores creativos establecen un calendario que se adapta a ti',
      others: 'Presión enorme por generar mucho contenido todas las semanas'
    }
  ];
  
  const features = config.comparisonFeatures || defaultFeatures;
  const comparisonTitle = config.comparisonTitle || '¿Por qué elegirnos sobre otros?';
  const comparisonSubtitle = config.comparisonSubtitle || 'Mira la comparación con otras agencias';

  return (
    <section ref={ref} className="py-24 bg-[#1d1e20] relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[#1d1e20]/90 z-10" />
        <img
          src="https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/3ezkdj4d_IMG_6782.JPG"
          alt="Background"
          className="w-full h-full object-cover opacity-15"
        />
      </div>

      <div className="absolute inset-0 opacity-5 z-10">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#c8784e] rounded-full filter blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 relative z-20">
        <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
          <p className="text-[#c8784e] uppercase tracking-wider mb-4 font-semibold">COMPARACIÓN</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {comparisonTitle}
          </h2>
          <p className="text-gray-400 text-lg">{comparisonSubtitle}</p>
        </div>

        <div className={`max-w-6xl mx-auto scale-in ${isVisible ? 'visible' : ''}`}>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="text-left py-6 px-4 text-gray-400 font-semibold"></th>
                  <th className="text-center py-6 px-4">
                    <span className="text-2xl font-bold text-[#c8784e]">JG Models</span>
                  </th>
                  <th className="text-center py-6 px-4">
                    <span className="text-xl font-semibold text-gray-500">Otras</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map((item, index) => (
                  <tr key={index} className="border-b border-gray-800 hover:bg-black/30 transition-colors">
                    <td className="py-6 px-4 font-light text-gray-400">{item.feature}</td>
                    <td className="py-6 px-4 text-center">
                      <div className="flex items-center justify-center gap-2">
                        <Check size={20} className="text-green-500 flex-shrink-0" />
                        <span className="text-white font-light">{item.jgm}</span>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center">
                      <div className="flex items-center justify-center gap-2">
                        <X size={20} className="text-red-500 flex-shrink-0" />
                        <span className="text-gray-500 font-light">{item.others}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;